import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Configs from "../../Service/Configuration";
import FetchApi from "../../Service/FetchApi";
import MaterialTable from "material-table";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Switch,
  TextField,
  Typography,
  InputLabel
} from "@material-ui/core";
import {
  utcToLocal,
  compareDateTimes,
  backgroundColourFromLetter,
} from "../HelperFunctions";
import { Card } from "@material-ui/core";
import { ResponsiveLine } from "@nivo/line";
import Avatar from "@material-ui/core/Avatar";
import CardHeader from "@material-ui/core/CardHeader";
import { red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import SelectSitesGrouping from "../SharedComponents/SelectSitesGrouping";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionActions from "@material-ui/core/AccordionActions";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CDialog from "Component/CDialog";
import FolderShared from "@material-ui/icons/FolderShared";
import DeleteIcon from "@material-ui/icons/Delete";
import { Autocomplete } from "@material-ui/lab";
import ListItem from "@material-ui/core/ListItem";
import { Grid } from "@material-ui/core";

class PairSitePage extends Component {
  constructor(props) {
    super();
    this.state = {
      ClinicBpIdField: "",
      FHTClinicIdField: "",
      PairingKeyField: "",
      responseFromHalo: "Please submit pairing request by inserting the clinic ID, pairing key, and selecting an existing FHT site",
      fhtSiteList: [],
      fhtSiteSelected: "",
    };
    FetchApi("GetSitesForPairing")
      .get()
      .then((response) => {
        this.setState({ fhtSiteList: response });
        console.log("fhtSiteList:", response);
      });
  }
  handleUserInputPairingField = (e) => {
    this.setState({ PairingKeyField: e.target.value });
  };
  handleUserInputIdField = (e) => {
    this.setState({ ClinicBpIdField: e.target.value });
  };
  onBtnSubmitPairing = (e) => {
    e.preventDefault();
    console.log("Submitting pairing");
    let body = {
      PracticeManagementSiteId: this.state.ClinicBpIdField,
      PairingCode: this.state.PairingKeyField,
      fhtsiteid: this.state.FHTClinicIdField,
    };
    let api = FetchApi("RegisterHaloSite");
    api.post(body).then((response) => {
      if (response == undefined || response == null) {
        throw "No response from FHT server";
      } else if (response.error != undefined || response.error != null) {
        throw response.error;
      } else {
        this.setState({ responseFromHalo: response });
      }
    });
  };
  siteSelectHandleChange = (e) => {
    e.preventDefault();
    console.log("Site select value changed");
    this.setState({
      fhtSiteSelected: e.target.value,
      FHTClinicIdField: e.target.value.fhtSiteId,
    });
  };
  render() {
    return (
      <div>
        <Grid item xs={12} md={6} lg={4}spacing={8}>
        <Box padding={12}>
        <Box display="flex" flexDirection="row">
              <TextField
                id="ClinicBpIdField"
                label="Insert Clinic Id"
                variant="standard"
                value={this.state.ClinicBpIdField}
                onChange={this.handleUserInputIdField}
              />


              <TextField
                id="PairingKeyField"
                label="Insert Pairing Key"
                variant="standard"
                value={this.state.PairingKeyField}
                onChange={this.handleUserInputPairingField}
              />

        </Box>
        <Box display="flex" flexDirection="row" style={{paddingTop:"1REM"}}>
            <FormControl variant="outlined" style={{minWidth:"15REM"}}>
              <InputLabel id="fhtsiteselectlabel">FHT sites</InputLabel>
              <Select
                labelId="fhtsiteselectlabel"
                id="fhtsiteselectlabel-outlined"
                value={this.state.fhtSiteSelected}
                onChange={this.siteSelectHandleChange}
                label="FHT Site"
              >
                {this.state.fhtSiteList.map((s) => (
                  <MenuItem key={s.fhtSiteId} value={s}>
                    {s.fhtSiteName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
                id="FHTClinicIdField"
                label="FHT's Site Id"
                variant="standard"
                disabled="true"
                value={this.state.FHTClinicIdField}
                style={{paddingLeft:"1REM"}}
                //onChange={this.handleUserInput}
              />
            </Box>
            <Box display="flex" flexDirection="row" style={{paddingTop:"1REM"}}>
            <Button
              onClick={(e) => this.onBtnSubmitPairing(e)}
              variant="outlined"
            >
              Submit pairing request
            </Button>
            </Box>
            <Box display="flex" flexDirection="row" style={{paddingTop:"1REM"}}>
          {this.state.responseFromHalo}
          </Box>
          </Box>
        </Grid>
      </div>
    );
  }
}
export default PairSitePage;
